import { BackgroundStyle, BorderSize, BorderStyle, ForegroundStyle } from '../../Style';
export var IconButtonType;
(function (IconButtonType) {
    IconButtonType["PanelTool"] = "panel_tool";
    IconButtonType["Action"] = "action_button";
})(IconButtonType || (IconButtonType = {}));
export const IconButtonTypeClass = {
    [IconButtonType.PanelTool]: `${BackgroundStyle.Secondary} ${BackgroundStyle.Outline} ${ForegroundStyle.OutlineElements} ${BorderStyle.General} ${BorderSize.Solid1}`,
    [IconButtonType.Action]: `${BackgroundStyle.Secondary} ${BackgroundStyle.Outline} ${ForegroundStyle.OutlineElements} ${BorderSize.None}`
};
